<script setup lang="ts">
    import Svg from "@/components/tellscale/utilities/Svg.vue";

    import TellscaleLogoLight from "@/assets/tellscale-logo-light.svg";
    import TellscaleLogoDark from "@/assets/tellscale-logo-dark.svg";

    import { useApp } from "@/stores/app";

    import type { HTMLAttributes } from "vue";

    const app = useApp();

    interface Props {
        size?: number;

        class?: HTMLAttributes["class"];
    }

    const props = withDefaults(defineProps<Props>(), {
        size: 10,
    });

    const logo = computed(() => app.isLightMode ? TellscaleLogoLight : TellscaleLogoDark);
</script>

<template>
    <Svg :svg="logo" v-bind="props" alt="Tellscale Logo"/>
</template>

<style scoped lang="scss">

</style>